import React from "react"

export default React.createContext({
    handleLogout: () => {},
    handleCheckDefinePwd: () => {},
    me: () => {}
})
